import type { Editor } from '@tiptap/core';
import { PopoverTrigger } from 'src/components/PopoverTrigger';
import Iconify from 'src/components/iconify';
import { useDragHandlerStore } from '../states/TableHandlerState';
import { Selection } from './Selection';
import { TableColumnOptionsPopover } from './TableColumnOptionsPopover';

export const TableColumnHandler = ({
  editor,
}: {
  editor: Editor;
}) => {
  const rects = useDragHandlerStore((state) => state.columnRects);

  return (
    <PopoverTrigger popover={TableColumnOptionsPopover} context={{ editor }}>
      <Selection rect={rects} placement="top">
        <Iconify fontSize={16} icon="tabler:dots" />
      </Selection>
    </PopoverTrigger>
  );
};
